// Chart show/hide config for the Org performance tab. The "Customize" dropdown
// (StaticMultiSelect) toggles which chart cards render; the selection persists
// per-organization in localStorage. The Summary KPI grid is always shown and is
// intentionally not part of this set.

export type OrgChartKey =
  | 'score_trend'
  | 'call_volume_trend'
  | 'performance_radar'
  | 'compliance_failure_rate'
  | 'escalation_rate'
  | 'question_rates'
  | 'ineligible_reason_breakdown'
  | 'call_analytics';

export interface OrgChartOption {
  value: OrgChartKey;
  label: string;
}

// Order here drives the "Customize" dropdown order; keep it aligned with the
// chart render order in AnalyticsMetricsView so the two read consistently.
export const ORG_CHART_OPTIONS: OrgChartOption[] = [
  { value: 'score_trend', label: 'Score Trend' },
  { value: 'call_volume_trend', label: 'Call Volume' },
  { value: 'performance_radar', label: 'Performance Radar' },
  { value: 'compliance_failure_rate', label: 'Compliance Failure Rate' },
  { value: 'escalation_rate', label: 'Escalation Rate' },
  { value: 'question_rates', label: 'Question Pass & Miss Rates' },
  { value: 'ineligible_reason_breakdown', label: "Why calls weren't scored" },
  { value: 'call_analytics', label: 'Call Analytics' },
];

const ALL_ORG_CHART_KEYS = ORG_CHART_OPTIONS.map(o => o.value);

export const isOrgChartKey = (value: string): value is OrgChartKey =>
  (ALL_ORG_CHART_KEYS as string[]).includes(value);

// Call Volume is the newly added, opt-in chart — hidden by default so existing
// dashboards are unchanged until a user turns it on. Everything else defaults on.
export const DEFAULT_VISIBLE_ORG_CHARTS: OrgChartKey[] = ALL_ORG_CHART_KEYS.filter(
  key => key !== 'call_volume_trend',
);

export const orgChartVisibilityStorageKey = (organizationId: string): string =>
  `analytics:org-charts:${organizationId}`;
